import { IntlShape } from 'react-intl';

import { errorMessages } from './messages';
import { ErrorNotificationProps } from './types';

interface UseLocalizedMessageProps extends Pick<
  ErrorNotificationProps,
  'code' | 'id' | 'info' | 'message'
> {
  formatMessage: IntlShape['formatMessage'];
}

export const useLocalizedMessage = (
  props: UseLocalizedMessageProps
): string => {
  const { formatMessage, id, code, message, info } = props;
  if (id === null) return formatMessage(errorMessages.systemError);
  if (id !== 'systemError') {
    const apiErrorMessage = errorMessages[id as keyof typeof errorMessages];
    if (apiErrorMessage) return formatMessage(apiErrorMessage);
  }
  if (info) return info;
  if (message) return message;
  return String(code);
};
